// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__xVjxS","col":"Table_col__19B4A","fulfillmentStatus":"Table_fulfillmentStatus__1Jhpr","emailCol":"Table_emailCol__3Y4_D"};